import '../web/assets/less/main.less'
import * as App from '../js/entrypoints/Common'

App.init({ entrypoint: 'Base' })
